export enum TicketType {    
    ContactPageMedia = 0,
    ContactPageNonMemberCenter = 1,
    DonorRequest = 2,
    RecipientRequest = 3,
    MemberCenterRequest = 4,
    DashRequest = 5,
    GeneralRequest = 6,
    SystemRelated = 7
}